import React,{useState,useEffect} from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import {AuthData} from '../Services/Authdata';
import {UserList} from '../Services/User';
import { useHistory } from "react-router-dom";

// Generate Order Data
function createData(id, date, name, shipTo, paymentMethod, amount) {
  return { id, date, name, shipTo, paymentMethod, amount };
}


const rows = [
  createData(0, '16 Mar, 2019', 'Elvis Presley', 'Tupelo, MS', 'VISA ⠀•••• 3719', 312.44),
  createData(1, '16 Mar, 2019', 'Paul McCartney', 'London, UK', 'VISA ⠀•••• 2574', 866.99),
  createData(2, '16 Mar, 2019', 'Tom Scholz', 'Boston, MA', 'MC ⠀•••• 1253', 100.81),
  createData(3, '16 Mar, 2019', 'Michael Jackson', 'Gary, IN', 'AMEX ⠀•••• 2000', 654.39),
  createData(4, '15 Mar, 2019', 'Bruce Springsteen', 'Long Branch, NJ', 'VISA ⠀•••• 5919', 212.79),
];


function preventDefault(event) {
  event.preventDefault();
}

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));


export default function Orders() {
  let history = useHistory();
  const [users, setUsers] = useState([]);
  const classes = useStyles();
  
  useEffect(() =>{
    UserList('user/list','GET',AuthData().token).then((result)=>{
      if(result.success === false){
        localStorage.removeItem('userData');
        history.push('/login');
      }else{
        if(result.status ===1){
          setUsers(result.data);
        }
      }
      
    })
  },[])
  return (
    <React.Fragment>
      <Title>Recent Users</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Mobile</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.slice(0, 5).map((row) => (
            
            <TableRow key={row.id}>
              <TableCell>{row.date}</TableCell>
              <TableCell>{row.user_name}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.mobile_number}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/* <div className={classes.seeMore}>
        <Link color="primary" to="/user">
          See more users
        </Link>
      </div> */}
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/component/Orders.js